import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import CommonModal from '../../UiKits/Modals/common/modal'
import { Card, Container } from 'reactstrap'
import { fetchAdmins } from '../../../firebase/utils'
import SeachBar from '../../UiKits/SearchBar'
import { Breadcrumbs, Btn } from '../../../AbstractElements'
import moment from 'moment'
import AdminAction from './AdminAction'

const AdminManagement = () => {
  const [search, setSearch] = useState('')
  const [admins, setAdmins] = useState([])
  const [loading, setloading] = useState(true)
  const [open, setOpen] = useState(false)

  const getAdmins = async () => {
    const admins = await fetchAdmins()
    setloading(false)
    setAdmins(admins)
  }

  const filterAdmins = admins.filter((item) =>
    item.email?.toLowerCase().includes(search.toLowerCase())
  );

  const tableColumns = [
    {
      title: "ID",
      dataIndex: "uid",
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: 'FULL NAME',
      dataIndex: "fullName",
      sorter: (a, b) => a.fullName.localeCompare(b.fullName),

    },
    {
      title: 'CREATEDAT',
      dataIndex: "createdAt",
      render: (data) => moment(data.seconds * 1000).format('LL')
    },
    {
      title: 'Action',
      render: (e) => <AdminAction data={e} open={open} setOpen={setOpen} getAdmins={getAdmins} admins={admins} setAdmins={setAdmins} />

    }
  ]


  useEffect(() => {
    getAdmins()
  }, [])
  return (
    <>
      <Breadcrumbs mainTitle={'Admin Management'} />
      <Container fluid={true} className="dashboard-default">
        <Card className='p-3'>
          <div className='d-flex align-items-center m-b-10'>
            <SeachBar search={search} setSearch={setSearch} />
            <Btn attrBtn={{ color: "primary", className: 'm-l-10', onClick: () => setOpen(true) }}>Create New Admin</Btn>
          </div>
          <div style={{ marginBottom: '100px' }} className='ant-design-table not-margin'>
            <Table
              loading={loading}
              columns={tableColumns}
              dataSource={filterAdmins}
              bordered={true}
              pagination={false}

              scroll={{ y: 800, x: 'auto' }}
            />
          </div>
        </Card>
      </Container>
    </>
  )
}

export default AdminManagement